// components.application.reports.applications.kbsChip

export const KBS_CHIP = {
  MAJOR: 'Key Business System',
  NONE: 'Not Key Business System',
  MINOR: 'Not Important'
};
